import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Warehouse extends CRUDService {
  constructor() {
    super(APIPath.warehouses);
  }

  updateWarehouse(id, payload) {
    return BaseService.patch(`${APIPath.warehouses}/${id}`, payload);
  }

  warehouseShipnodes(id) {
    return BaseService.get(`${APIPath.warehouses}/${id}/shipnodes`);
  }

  getWarehouseEmail(id) {
    return BaseService.get(`${APIPath.warehouseEmailConfig}/${id}`);
  }

  updateWarehouseEmail(id, data) {
    return BaseService.post(`${APIPath.warehouseEmailConfig}/${id}`, data);
  }
}

const WarehouseService = new Warehouse();
Object.freeze(WarehouseService);
export { WarehouseService };
